<template>
    <v-container>
        <v-btn color="primary" :to="{ name: 'survey.group.add', params: { id: selectedSurvey.id } }" :disabled="selectedSurvey.archived">
            <v-icon>add</v-icon>
            Créer un groupe de questions
        </v-btn>

        <v-data-table
            class="my-4"
            :headers="headers"
            :items="selectedSurvey.groups"
            :search="search"
            :pagination.sync="paginator">
            <template v-slot:items="props">
                <td>{{ props.item.position }}</td>
                <td>{{ props.item.name !== '' ? props.item.name : '-' }}</td>
                <td v-html="props.item.instructions"></td>
                <td>{{ props.item.questions.length }}</td>
                <v-btn flat
                       :to="{name: 'survey.group.edit', params: { id: selectedSurvey.id, groupId: props.item.id } }"
                          :disabled="selectedSurvey.archived">
                    <v-icon>edit</v-icon>
                </v-btn>
            </template>
            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Aucun résultat pour "{{ search }}".
                </v-alert>
            </template>
        </v-data-table>

    </v-container>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: "SurveyDetails",
    data() {
        return {
            has_error: false,
            search: '',
            headers: [
                {text: 'Position', align: 'left', value: 'position'},
                {text: 'Name', align: 'left', value: 'name'},
                {text: 'Description', align: 'left', value: 'instructions'},
                {text: 'Nombres de Questions', align: 'left', value: 'number_questions'},
            ],
            paginatorText: "Résultats par page",
            paginator: {
                rowsPerPage: 25,
                sortBy: 'position',
                //descending:true
            }
        }
    },
    components: {},
    computed: {
        ...mapState('surveys', {
            selectedSurvey: state => state.selected_score
        }),
    }
}
</script>

<style scoped>

</style>
